export const fragenMotorschaden = [
  {
    question: "Kann ich mein Auto auch ohne TÜV verkaufen?",
    answer: (
      <>
        <p>
          Ja, auch ohne gültigen TÜV kannst du dein Auto über Autoeinfachlos
          verkaufen. Der Händler kümmert sich um alles Weitere.
        </p>
      </>
    ),
  },
  {
    question: "Muss ich den Schaden detailliert angeben?",
    answer: (
      <>
        <p>
          Eine ehrliche Angabe ist wichtig. So erhältst du ein realistisches
          Angebot und vermeidest später Probleme.
        </p>
      </>
    ),
  },
  {
    question: "Welche Unterlagen brauche ich für den Verkauf?",
    answer: (
      <>
        <p>
          Im Regelfall benötigst du:
        </p>
        <ul className="AV-Fragen-ul">
          <li>
            <strong>Fahrzeugschein und Fahrzeugbrief</strong>
          </li>
          <li>
            <strong>Personalausweis oder Reisepass</strong>
          </li>
          <li>
            <strong>Service- und Reparaturunterlagen (falls vorhanden)</strong>
          </li>
        </ul>
      </>
    ),
  },
];
